import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { OrderMealEntree, Menu, BasicOrderMealItemWithContents } from '@/models';

@Component({
  name: 'CmgEntreeCard',
})
export default class CmgEntreeCard extends Vue {
  @Prop({ required: true })
  public entree!: OrderMealEntree;

  get formattedEntree(): string {
    if (!this.menu) {
      return '';
    }

    return this.getFormattedDetails(this.entree, this.menu);
  }

  get entreePrice(): string {
    return this.$services.utils.formatPrice(this.entree.entreeExtendedPrice);
  }

  get menu(): Menu | null {
    return this.$appStore.state.menu.activeMenu;
  }

  getFormattedDetails(orderEntree: BasicOrderMealItemWithContents, menu: Menu) {
    return this.$services.entree.getFormattedDetails(orderEntree, menu);
  }
}
